export enum StatementTypeModalModes {
  CREATE = "create",
  EDIT = "edit",
  VIEW = "view",
}
